import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-unauthorized-layout',
  templateUrl: './unauthorized-layout.component.html',
  styleUrls: ['./unauthorized-layout.component.scss']
})
export class UnauthorizedLayoutComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
